import { SimpleGrid } from "@mantine/core";
import { ConversationsChart } from "../../../components/charts/ConversationsChart";
import { ChatMessagesChart } from "../../../components/charts/ChatMessagesChart";
import { AverageChatMessagesChart } from "../../../components/charts/AverageChatMessagesChart";
import { PeakHoursChart } from "../../../components/charts/PeakHoursChart";
import { TouchpointChart } from "../../../components/charts/TouchpointChart";

const HistoryInsightsPage = () => {
    return (
        <SimpleGrid cols={{ base: 1, xl: 2 }} spacing="lg">
            <ConversationsChart title="CONVERSATIONS" height={360} defaultAggregation="day" />
            <ChatMessagesChart title="MESSAGES" height={360} defaultAggregation="day" />
            <AverageChatMessagesChart title="AVERAGE MESSAGES PER CONVERSATION" height={360} defaultAggregation="day" />
            <PeakHoursChart title="PEAK HOURS ACTIVITY" height={360} />
            <TouchpointChart title="TOUCHPOINT DISTRIBUTION" height={360} />
        </SimpleGrid>
    );
};

export default HistoryInsightsPage;
